import RiskScore from './riskScore';

export default RiskScore;
